import {TimeRange} from 'bitmovin-player';

/**
 * Calculates the percentage of media that has been buffered.
 *
 * @param buffered the buffered segments
 * @param timestamp the current timestamp of the media
 * @param duration the duration of the media asset
 * @returns percentage buffered
 */
export function calculateBuffer(
  buffered: TimeRange[],
  timestamp: number,
  duration: number
): number {
  const bufferLengths = buffered.map((buffer) => buffer.end - buffer.start);

  const minBufferedLength = bufferLengths.length
    ? Math.min(...bufferLengths)
    : 0;
  const buffer = minBufferedLength + timestamp;

  return (buffer / duration) * 100;
}
